var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8324 0.499023H2.16569C1.24902 0.499023 0.499023 1.24902 0.499023 2.16569V13.8324C0.499023 14.749 1.24902 15.499 2.16569 15.499H13.8324C14.749 15.499 15.499 14.749 15.499 13.8324V2.16569C15.499 1.24902 14.749 0.499023 13.8324 0.499023ZM13.8324 2.1657V13.8324H2.1657V2.1657H13.8324ZM7.28205 11.1073L9.78205 7.88226L12.9987 12.1656H2.99872L5.49872 8.94893L7.28205 11.1073Z",
    fill: "#CDD3DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatIcon);
export default __webpack_public_path__ + "static/media/cat-icon.dc73122b51ff21a1f22ced46c00a6163.svg";
export { ForwardRef as ReactComponent };